import { cn } from 'components/UI/cn'

/**
 * Shared className construction for filter-row trigger buttons. Keeps the
 * inactive / open / active strokes byte-identical across the FilterButton
 * pill (used by the value/range filters) and the DateRangePicker trigger
 * on the event-history pages — so they read as one consistent set of
 * dropdowns. Extracted to prevent silent drift between the two callers.
 */
export function filterTriggerClasses({
  open,
  isActive,
}: {
  open: boolean
  isActive: boolean
}) {
  return cn(
    'flex-1 w-100 relative min-h-[36px] px-3 !py-0 rounded-lg',
    'text-fg hover:text-fg',
    'focus:outline-none focus-visible:outline-none',
    '!border !border-neutral-300 hover:!border-neutral-400',
    {
      '!bg-surface !border-brand-active hover:!border-brand-active ring-4 ring-brand-active/20':
        open,
      '!bg-basil-50 hover:!bg-basil-100 !border-basil-600 hover:!border-basil-600 !text-brand-active':
        isActive && !open,
    }
  )
}
